module.exports = __webpack_public_path__ + "static/media/whurd.2cec0cab.png";